<script setup lang="ts">
import { sizes, stylesLink as styles, type ISizes, type IStyles } from './styles';

interface Props {
  styleName?: IStyles | null | undefined;
  size?: ISizes | null | undefined;
  value?: String | string | undefined;
  target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  href?: String | string | undefined;
  block?: boolean | undefined;
  disabled?: boolean | undefined;
  external?: boolean | undefined;
  rounded?: boolean | undefined;
  [x: string]: any;
}

const props = withDefaults(defineProps<Props>(), {
  rounded: true,
  styleName: 'default'
});

const emit = defineEmits(['click', 'change', 'focus']);
</script>

<template>
  <NuxtLink
    v-if="href"
    :class="[
      ('text-auto'),
      (rounded && 'rounded-auto'),
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      ((! disabled) && styles[styleName]),
      (disabled && styles['muted'])
    ]"
    :formtarget="target"
    :target="target"
    :disabled="(disabled ? true : undefined)"
    :external="external"
    :href="((! disabled) ? href : null)"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @change="(e: Event) => ((! disabled) ? emit('change', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot>
      {{ value }}
    </slot>
  </NuxtLink>
  <button
    v-else
    :class="[
      ('text-auto'),
      (rounded && 'rounded-auto'),
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      ((! disabled) && styles[styleName]),
      (disabled && styles['muted'])
    ]"
    :formtarget="target"
    :target="target"
    :disabled="disabled"
    :external="external"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @change="(e: Event) => ((! disabled) ? emit('change', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot>
      {{ value }}
    </slot>
  </button>
</template>
